
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";
import { useEffect } from "react";
import { LoadingScreen } from "@/components/ui/loading-screen";

const AdminRoute = ({ children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const { toast } = useToast();
  
  useEffect(() => {
    if (user && user.role !== "company_super_admin" && user.role !== "company_admin") {
      toast({
        title: "Access Denied",
        description: "You don't have permission to access this page.",
        variant: "destructive",
      });
    }
  }, [user, toast]);

  if (isLoading) {
    return <LoadingScreen message="Loading admin portal..." />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }

  if (user.role !== "company_super_admin" && user.role !== "company_admin") {
    if (user.role === "master_admin") {
      return <Navigate to="/master-admin" />;
    } else if (user.role === "candidate") {
      return <Navigate to="/candidate" />;
    } else {
      return <Navigate to="/login" />;
    }
  }

  return children;
};

export default AdminRoute;
